module.exports = __webpack_public_path__ + "img/news-m-banner.5f2a0a7b.png";